/**
* @copyright Copyright (C) 2020 Kokoon - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*/

import { useState, useEffect } from 'react';
import { Auth, Hub } from 'aws-amplify';

/**
 * useUserStatus is a react hook that tracks the user's login status
 */
const useUserStatus = () => {
  /**
   * We initialize the user with undefined, meaning we are
   * waiting for the AWS Auth data.
   */
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    let didCancel = false;
    const updateUser = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        if (!didCancel) {
          setUser(currentUser);
        }
      } catch (error) {
        if (!didCancel) {
          setUser(null);
        }
      }
    };
    Hub.listen('auth', updateUser); /** listen for login/signup events */

    /** we are not using async to wait for updateUser
     * so there will be a flash of page where the user is assumed not to be logged in
     */
    updateUser(); /** check manually the first time because we won't get a Hub event */
    return () => {
      didCancel = true;
      Hub.remove('auth', updateUser); /** cleanup */
    };
  }, []);

  return user;
};

export default useUserStatus;
